

import { useCallback } from 'react';
import { deleteRemovedImages } from '../utils/imageUtils';

/**
 * Hook to handle image change for components with single image upload.
 *
 * @param {object} uploadTarget - The object containing original image data (e.g., a menu item).
 * @param {function} setSelectedFile - React state setter for selected file.
 * @param {function} setPreviewImage - React state setter for preview image.
 * @returns {function} handleImageChange callback
 */
export default function useImageChangeHandler(uploadTarget, setSelectedFile, setPreviewImage) {
  return useCallback((updatedUrls = []) => {
    if (!uploadTarget) return;

    const previousImage = uploadTarget.image ? [uploadTarget.image] : [];
    const selected = Array.isArray(updatedUrls) && updatedUrls.length > 0 ? updatedUrls[0] : null;

    deleteRemovedImages(previousImage, updatedUrls);

    if (selected?.startsWith('http')) {
      setSelectedFile(selected);
      setPreviewImage(selected);
    } else if (!selected) {
      setSelectedFile(null);
      setPreviewImage(null);
    }
  }, [uploadTarget, setSelectedFile, setPreviewImage]);
}